import React from 'react';
import { Modal, Form, Input, Row, Col, Select, Button } from 'antd';

const { TextArea } = Input;

const RoutineDayExerciseModal = ({
  visible,
  onCancel,
  onSubmit,
  form,
  exerciseOptions,
  groupOptions = [],
  loadingGroups = false,
  editingExercise,
  loading,
}) => {

  const selectedExerciseId = Form.useWatch('exercise_id', form);

  const selectedExercise = exerciseOptions.find(
    (option) => option.value === selectedExerciseId
  );

  const executionTypeName = selectedExercise?.type;

  const setLabel = executionTypeName ? `Set (${executionTypeName})` : 'Set ()';


  return(
  <Modal
    title="Elige tu ejercicio"
    open={visible}
    onCancel={onCancel}
    footer={[
      <Button key="cancel" onClick={onCancel}>
        Cancelar
      </Button>,
      <Button
        key="submit"
        type="primary"
        danger
        loading={loading}
        onClick={onSubmit}
      >
        {editingExercise ? 'Guardar cambios' : '+ Agregar ejercicio'}
      </Button>,
    ]}
    styles={{
      content: {
        border: '2px solid var(--sthenus-primary)',
        borderRadius: 16,
      },
    }}
  >
    <Form
      form={form}
      layout="vertical"
      autoComplete="off"
    >
      <Form.Item
        label="Ejercicio"
        name="exercise_id"
        rules={[{ required: true, message: 'Debes seleccionar un ejercicio' }]}
      >
        <Select
          showSearch
          placeholder="Elige ejercicio"
          optionFilterProp="label"
          options={exerciseOptions}
        />
      </Form.Item>

      <Form.Item
        label="Grupo"
        name="routine_day_group_id"
        rules={[{ required: true, message: 'Selecciona un grupo o "Sin grupo"' }]}
      >
        <Select
          showSearch
          placeholder="Sin grupo o elige grupo"
          optionFilterProp="label"
          options={groupOptions}
          loading={loadingGroups}
        />
      </Form.Item>

      <Row gutter={16}>
        <Col xs={24} md={12}>
          <Form.Item
            label={setLabel}
            name="sets"
          >
            <Input placeholder="#" />
          </Form.Item>
        </Col>
        <Col xs={24} md={12}>
          <Form.Item
            label="Posición"
            name="position"
            rules={[
              { required: true, message: 'La posición es requerida' },
              {
                validator: (_, value) => {
                  const num = Number(value);
                  if (!value || Number.isNaN(num) || num < 1) {
                    return Promise.reject(new Error('Debe ser un número mayor a 0'));
                  }
                  return Promise.resolve();
                },
              },
            ]}
          >
            <Input type="number" min={1} placeholder="1" />
          </Form.Item>
        </Col>
      </Row>

      <Form.Item
        label="Peso"
        name="weight"
      >
        <Input placeholder="Ej. Peso recomendado" />
      </Form.Item>

      <Form.Item
        label="Instrucciones extras"
        name="extra_instructions"
      >
        <TextArea rows={4} placeholder="Notas adicionales para este ejercicio" />
      </Form.Item>
    </Form>
  </Modal>)
};

export default RoutineDayExerciseModal;
